import { makeStyles } from '@material-ui/core/styles';
import { commonStyles } from 'UI/constants/styles';

export const useComposerStyles = makeStyles(theme => ({
  composerContainer: {
    alignItems: 'center',
    backgroundColor: theme.palette.grey[50],
    boxShadow: commonStyles.drawerFooter.boxShadow,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  }
}));
